import React from "react";
import { MdOutlineCancel } from "react-icons/md";
import { NavLink } from "react-router-dom";
import { IoCallOutline } from "react-icons/io5";
import { SiContactlesspayment } from "react-icons/si";
import { TbSmartHome } from "react-icons/tb";
import { useStateContext } from "../../context/contextProvider";
import { dataCards } from "../../data/data";
import { SiInformatica } from "react-icons/si";


const SideNavbar = () => {
  const { setThemeSettings } = useStateContext();
  return (
    <div>
      <div className="tw-bg-transparent-black tw-w-full tw-fixed tw-nav-item tw-top-0 tw-right-0 tw-z-5 tw-duration-500">
        <div className="tw-bg-white tw-h-screen tw-w-[400px] sm:tw-w-[300px] xs:tw-w-[230px]">
          <button
            type="button"
            onClick={() => setThemeSettings(false)}
            className="tw-text-2xl sm:tw-text-xl tw-text-second-zain tw-shadow-sm tw-rounded-md hover:tw-bg-gray-100 hover:tw-text-red-500 tw-p-2 sm:tw-p-1 tw-mt-3 tw-mr-3"
          >
            <MdOutlineCancel />
          </button>
          <div className="tw-w-full tw-p-4 tw-flex tw-flex-col tw-gap-3 tw-items-center tw-pt-8">
            <NavLink
              to="/"
              className="tw-w-full tw-p-4 sm:tw-p-3 xs:tw-text-sm xs:tw-p-2 tw-flex tw-items-center tw-gap-2 tw-whitespace-nowrap tw-shadow-sm tw-border tw-border-gray-50 tw-border-r-2 tw-border-r-second-zain hover:tw-bg-second-zain active:tw-bg-second-zain hover:tw-text-white active:tw-text-white tw-rounded-md tw-transition-all tw-duration-500 tw-ease-linear "
              onClick={() => setThemeSettings(false)}
            >
              <span>
                <TbSmartHome />
              </span>
              <span>الرئيسية</span>
            </NavLink>
            {dataCards.map((item, index) => (
              <NavLink
              key={index}
                to={item.links}
                className="tw-w-full tw-p-4 sm:tw-p-3 xs:tw-text-sm xs:tw-p-2 tw-flex tw-items-center tw-gap-2 tw-whitespace-nowrap tw-shadow-sm tw-border tw-border-gray-50 tw-border-r-2 tw-border-r-second-zain hover:tw-bg-second-zain active:tw-bg-second-zain hover:tw-text-white active:tw-text-white tw-rounded-md tw-transition-all tw-duration-500 tw-ease-linear "
                onClick={() => setThemeSettings(false)}
              >
                <span>
                  {item.icon}
                </span>
                <span>{item.title}</span>
              </NavLink>
            ))}
            <NavLink
            to="/about"
              className="tw-w-full tw-p-4 sm:tw-p-3 xs:tw-text-sm xs:tw-p-2 tw-flex tw-items-center tw-gap-2 tw-whitespace-nowrap tw-shadow-sm tw-border tw-border-gray-50 tw-border-r-2 tw-border-r-second-zain hover:tw-bg-second-zain active:tw-bg-second-zain hover:tw-text-white active:tw-text-white tw-rounded-md tw-transition-all tw-duration-500 tw-ease-linear "
              onClick={() => setThemeSettings(false)}
            >
              <span>
                <SiInformatica />
              </span>
              <span>عن المنصة</span>
            </NavLink>
            <NavLink
              className="tw-w-full tw-p-4 sm:tw-p-3 xs:tw-text-sm xs:tw-p-2 tw-flex tw-items-center tw-gap-2 tw-whitespace-nowrap tw-shadow-sm tw-border tw-border-gray-50 tw-border-r-2 tw-border-r-second-zain hover:tw-bg-second-zain active:tw-bg-second-zain hover:tw-text-white active:tw-text-white tw-rounded-md tw-transition-all tw-duration-500 tw-ease-linear "
              onClick={() => setThemeSettings(false)}
            >
              <span>
                <SiContactlesspayment />
              </span>
              <span>إشترك الان</span>
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideNavbar;
